export default function Unauthorized() {
  return <div>Unauthorized</div>;
}
